import { render, staticRenderFns } from "./TopicsInsightsTable.vue?vue&type=template&id=61a4bfd4&"
import script from "./TopicsInsightsTable.vue?vue&type=script&lang=js&"
export * from "./TopicsInsightsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports